import LogRocket from 'logrocket';
export { default as wrapPageElement } from './src/wrapElement/wrapPageElement';
export { default as wrapRootElement } from './src/wrapElement/wrapRootElement';

export function onInitialClientRender() {
  if (process.env.GATSBY_LOGROCKET_KEY != null) {
    LogRocket.init(process.env.GATSBY_LOGROCKET_KEY);
  }
}
